import TrainCard from "./TrainCard";

export default function TrainList({ trains, setTrainSelected, setLoadingTrain, onLiveUpdate }) {


  if (trains.length === 0) {
    return <div className="no-data">Não há dados para serem visualizados</div>;
  }

  return (
    <div className="train-list">
      {trains.map(train => (
        <TrainCard
          key={train.id}
          train={train}
          setTrainSelected={setTrainSelected}
          setLoadingTrain={setLoadingTrain}
          onLiveUpdate={onLiveUpdate}
        />
      ))}
    </div>
  );
}
